import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { getArticleBySlug, getRelatedArticles } from "../articlesData";
import ArticleHero from "../components/blog/ArticleHero";
import ArticleBody from "../components/blog/ArticleBody";
import ArticleGrid from "../components/blog/ArticleGrid";

export default function ArticleDetail() {
  const { slug } = useParams();
  const article = getArticleBySlug(slug);

  if (!article) {
    return <Navigate to="/blog" replace />;
  }

  const related = getRelatedArticles(article);
  const relatedTitle = `More ${article.tag} Stories`;

  return (
    <>
      <ArticleHero article={article} />
      <ArticleBody article={article} />
      <ArticleGrid title={relatedTitle} articles={related} />
    </>
  );
}
